const SPELLCHECK_SELECTOR = 'input, textarea, [contenteditable="true"]';

const disableSpellcheckOnElement = (el) => {
    if (!el || el.nodeType !== 1) {
        return;
    }
    if (el.matches && el.matches(SPELLCHECK_SELECTOR)) {
        el.setAttribute('spellcheck', 'false');
    }
    if (el.querySelectorAll) {
        el.querySelectorAll(SPELLCHECK_SELECTOR).forEach((node) => {
            node.setAttribute('spellcheck', 'false');
        });
    }
};

export const disableSpellcheckGlobally = () => {
    if (typeof document === 'undefined') {
        return;
    }

    document.documentElement.setAttribute('spellcheck', 'false');
    if (document.body) {
        document.body.setAttribute('spellcheck', 'false');
        disableSpellcheckOnElement(document.body);
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                disableSpellcheckOnElement(node);
            });
        });
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
};
